package horcrux.frontend.common.views.components.input

import horcrux.common.HasBetterToString
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.value
import horcrux.frontend.common.views.components.containers.HStack
import mui.material.FormControlMargin
import mui.material.TextField
import mui.material.TextFieldProps
import mui.system.sx
import react.FC
import react.Props
import react.dom.onChange
import web.cssom.JustifyContent
import web.cssom.pct
import web.cssom.pt

external interface EditTextFieldProps<A : HasBetterToString> : Props {
    var textFieldValueMaybeState: MaybeState<A>
    var defaultValueMaybe: String?
    var helpTextMaybe: String?
    var textFieldPropsMaybe: TextFieldProps?
}

typealias TextFieldValueConstructor<A> = (String) -> A

fun <A : HasBetterToString> TextFieldValueConstructor<A>.editTextField(
    blockMaybe: (TextFieldProps.() -> Unit)? = null
): FC<EditTextFieldProps<A>> = FC { props ->
    HStack {
        this.sx {
            this.justifyContent = JustifyContent.center
            this.width = 100.pct
        }
        TextField {
            +props.textFieldPropsMaybe
            blockMaybe?.let { it() }
            this.margin = FormControlMargin.dense
            this.value = props.textFieldValueMaybeState.get()?.betterToString() ?: props.defaultValueMaybe
            this.onChange = { event ->
                props.textFieldPropsMaybe?.onChange?.let { it(event) }
                this@editTextField(event.value())
                    .let { props.textFieldValueMaybeState.set(it) }
            }
        }

        props.helpTextMaybe?.let {
            InfoPopover {
                this.id = "edit-text-field-help"
                this.text = it
                this.sx {
                    this.marginLeft = 5.pt
                }
            }
        }
    }
}
